import { render, staticRenderFns } from "./PriceRuleForm.vue?vue&type=template&id=7008b0ea&scoped=true&"
import script from "./PriceRuleForm.vue?vue&type=script&lang=js&"
export * from "./PriceRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008b0ea",
  null
  
)

export default component.exports